export default "__VITE_ASSET__DUbve5_X__"